import React, { useState, useEffect } from 'react';
import { db } from '../../firebase';
import { ref, onValue } from 'firebase/database';
import { useNavigate } from 'react-router-dom';
import InchargeLayout from './InchargeLayout';
import { FaFileAlt, FaTrash, FaSearch, FaEye } from 'react-icons/fa';

const UpdateLEStatus = () => {
    const navigate = useNavigate();
    const [applications, setApplications] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        const appsRef = ref(db, 'ekamwatapzp/LimitExpandApplications');
        const unsubscribe = onValue(appsRef, (snapshot) => {
            if (snapshot.exists()) {
                const data = snapshot.val();
                const list = Object.keys(data).map(key => ({
                    id: key,
                    ...data[key]
                }));
                setApplications(list);
            } else {
                setApplications([]);
            }
            setLoading(false);
        });

        return () => unsubscribe();
    }, []);

    const filteredData = applications.filter(app =>
        app.applicantName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        app.phoneNo?.includes(searchTerm)
    );

    const getStatusStyle = (status) => {
        if (status === 'Pending') return 'text-amber-500 font-bold';
        if (status === 'Approved') return 'text-emerald-600 font-bold';
        if (status === 'Rejected') return 'text-rose-600 font-bold';
        return 'text-gray-500 font-bold';
    };

    return (
        <InchargeLayout>
            <div className="min-h-screen bg-[#f8f9fa] flex flex-col ">
                {/* Header Section */}
                <div className="px-6 py-6 flex flex-col md:flex-row md:items-center justify-between gap-4">
                    <h1 className="text-xl font-medium text-gray-700">लिमिट एक्सपायंड ॲप्लिकेशन</h1>
                    <div className="flex items-center text-sm font-medium text-gray-500 gap-2">
                        <span>सांगली जिल्हा परिषद</span>
                        <span>/</span>
                        <span className="text-gray-600 font-semibold tracking-tight">व्हिव लिमिट एक्सपायंड फॉर्म</span>
                    </div>
                </div>

                <div className="px-6 pb-12">
                    <div className="max-w-[100%] mx-auto bg-white rounded-lg shadow-sm border border-gray-200 p-6">

                        {/* Table Controls */}
                        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6">
                            <div className="flex items-center rounded overflow-hidden shadow-sm border border-gray-300">
                                <button className="bg-[#6c757d] hover:bg-[#5a6268] text-white px-4 py-1.5 text-sm font-medium border-r border-gray-500 transition-colors">Copy</button>
                                <button className="bg-[#6c757d] hover:bg-[#5a6268] text-white px-4 py-1.5 text-sm font-medium border-r border-gray-500 transition-colors">Excel</button>
                                <button className="bg-[#6c757d] hover:bg-[#5a6268] text-white px-4 py-1.5 text-sm font-medium transition-colors">Print</button>
                            </div>

                            <div className="flex items-center gap-2">
                                <label className="text-sm font-medium text-gray-600">Search:</label>
                                <input
                                    type="text"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    className="border border-gray-300 rounded px-3 py-1.5 text-sm outline-none focus:ring-1 focus:ring-blue-400 focus:border-blue-400"
                                />
                            </div>
                        </div>

                        {/* Data Table */}
                        <div className="overflow-x-auto border border-gray-200 rounded text-[#344767]">
                            <table className="w-full text-left text-[13px] border-collapse">
                                <thead>
                                    <tr className="bg-white border-b border-gray-200 font-bold divide-x divide-gray-200">
                                        <th className="px-3 py-4 w-12 text-center"># <span className="text-[9px] ml-0.5">↑↓</span></th>
                                        <th className="px-3 py-4 min-w-[160px]">Applicant Name <span className="text-[9px] ml-0.5">↑↓</span></th>
                                        <th className="px-3 py-4">Phone No. <span className="text-[9px] ml-0.5">↑↓</span></th>
                                        <th className="px-3 py-4">Reg. Date <span className="text-[9px] ml-0.5">↑↓</span></th>
                                        <th className="px-3 py-4">Appr. / Rej Date <span className="text-[9px] ml-0.5">↑↓</span></th>
                                        <th className="px-3 py-4 min-w-[120px]">Reupload Date <span className="text-[9px] ml-0.5">↑↓</span></th>
                                        <th className="px-3 py-4">Add. CEO Status <span className="text-[9px] ml-0.5">↑↓</span></th>
                                        <th className="px-3 py-4">Ex. Engineer Status <span className="text-[9px] ml-0.5">↑↓</span></th>
                                        <th className="px-3 py-4">Sr. Accountant Status <span className="text-[9px] ml-0.5">↑↓</span></th>
                                        <th className="px-3 py-4">Jr./ Sr. Assistant Status <span className="text-[9px] ml-0.5">↑↓</span></th>
                                        <th className="px-3 py-4 w-24">Action <span className="text-[9px] ml-0.5">↑↓</span></th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-200">
                                    {loading ? (
                                        <tr><td colSpan="11" className="text-center py-10 text-gray-400 italic">Data Loading...</td></tr>
                                    ) : filteredData.length > 0 ? (
                                        filteredData.map((app, index) => (
                                            <tr key={app.id} className={`${index % 2 === 0 ? 'bg-white' : 'bg-gray-50/30'} hover:bg-gray-100 transition-colors divide-x divide-gray-200`}>
                                                <td className="px-3 py-6 text-center font-medium">{index + 1}</td>
                                                <td className="px-3 py-6 font-bold leading-tight">{app.applicantName}</td>
                                                <td className="px-3 py-6">{app.phoneNo}</td>
                                                <td className="px-3 py-6">{app.regDate || 'N/A'}</td>
                                                <td className="px-3 py-6">{app.approvalDate || 'N/A'}</td>
                                                <td className="px-3 py-6 text-gray-700 leading-snug">
                                                    {app.reuploadDate || 'N/A'}
                                                </td>
                                                <td className={`px-3 py-6 ${getStatusStyle(app.ceoStatus || 'Pending')}`}>
                                                    {app.ceoStatus || 'Pending'}
                                                </td>
                                                <td className={`px-3 py-6 ${getStatusStyle(app.engineerStatus || 'Pending')}`}>
                                                    {app.engineerStatus || 'Pending'}
                                                </td>
                                                <td className={`px-3 py-6 ${getStatusStyle(app.accountantStatus || 'Pending')}`}>
                                                    {app.accountantStatus || 'Pending'}
                                                </td>
                                                <td className={`px-3 py-6 ${getStatusStyle(app.assistantStatus || 'Pending')}`}>
                                                    {app.assistantStatus || 'Pending'}
                                                </td>
                                                <td className="px-3 py-6">
                                                    <div className="flex items-center gap-4 text-gray-500">
                                                        <button
                                                            onClick={() => navigate(`/main-limit-expand-status/${app.id}`)}
                                                            className="hover:text-blue-500 transition-colors"
                                                            title="अपडेट करा"
                                                        >
                                                            <FaFileAlt size={16} />
                                                        </button>
                                                        <button className="hover:text-rose-500 transition-colors" title="डिलीट">
                                                            <FaTrash size={16} />
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="11" className="px-6 py-12 text-center text-gray-500 font-medium">
                                                No data available in table
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </InchargeLayout>
    );
};

export default UpdateLEStatus;
